

















import Vue from 'vue'
import { IJob } from '../store/state'

interface JobProps {
	job: IJob
}

export default Vue.extend<{}, {}, {}, JobProps>({
	name: 'Job',
	props: {
		job: {}
	}
})
